import { render, staticRenderFns } from "./CustomerMail.vue?vue&type=template&id=a36c1bd2&"
import script from "./CustomerMail.vue?vue&type=script&lang=js&"
export * from "./CustomerMail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerMail.vue"
export default component.exports